/**
 * 大会対戦表/ブラケット画面のUI定数
 */

export const TOURNAMENT_BRACKET_LAYOUT = {
  titleY: 30,
  matchInfoY: 60,
  tableStartY: 90,
  tableRowHeight: 28,
  bracketStartX: 50,
  bracketStartY: 90,
  bracketMatchWidth: 180,
  bracketMatchHeight: 40,
  bracketRoundSpacing: 220,
  bracketMatchSpacing: 50,
  actionButtonY: 480,
  actionButtonSpacing: 150,
  standingsStartX: 650,
  standingsStartY: 90,
} as const;

export const TOURNAMENT_BRACKET_LABELS = {
  roundRobinTitle: '総当たり戦',
  eliminationTitle: 'トーナメント戦',
  nextMatch: '次の試合',
  battle: 'バトル開始',
  watch: '観戦',
  skip: 'スキップ',
  viewResult: '結果を見る',
  vs: 'VS',
  matchProgress: (current: number, total: number) => `${current} / ${total} 試合完了`,
  roundNames: ['準々決勝', '準決勝', '決勝'] as readonly string[],
  standings: '順位表',
  rank: '順位',
  name: '名前',
  win: '勝',
  lose: '負',
  draw: '分',
  pts: '勝点',
} as const;
